import type { JSX } from 'react'
import RequirePermission from '../../components/auth/RequirePermission.js'
import SafetyPanel from '../../components/admin/ai/SafetyPanel.js'

/**
 * Standalone Safety & Guardrails page — renders the same SafetyPanel used by
 * the Safety tab inside the AI Agents page so both surfaces stay identical.
 */
export default function AiSafetyPage(): JSX.Element {
  return (
    <RequirePermission permission="admin:extensions:view">
      <SafetyPanel />
    </RequirePermission>
  )
}
